import { render, staticRenderFns } from "./TgpBase.vue?vue&type=template&id=b5794978"
import script from "./TgpBase.vue?vue&type=script&lang=js"
export * from "./TgpBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports